import prepareOptions from './prepareOptions';

export default (options) => {
  options = prepareOptions(options);

  return () => options;
};
